import { render, staticRenderFns } from "./SearchLeftSection.vue?vue&type=template&id=6b39a71c&scoped=true"
import script from "./SearchLeftSection.vue?vue&type=script&lang=js"
export * from "./SearchLeftSection.vue?vue&type=script&lang=js"
import style0 from "./SearchLeftSection.vue?vue&type=style&index=0&id=6b39a71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39a71c",
  null
  
)

export default component.exports